import React from 'react';

import TopPlayers from './components/TopPlayers';
import TopMaps from './components/TopMaps';
import NewMaps from './components/NewMaps';
import TopRecordHolders from './components/TopRecordHolders';
import RecentRecords from './components/RecentRecords';

const App = () => {
  return (
    <div className="font-sans bg-gray-900 text-gray-100 min-h-screen">
      {/* Navbar */}
      <nav className="flex justify-between items-center px-6 py-4 bg-gray-800 text-white sticky top-0 z-50">
		<div className="text-xl font-bold"><img className='h-16' src="https://insanitygaming.net/forums/data/assets/logo/style-logoooo3.png" alt="insanitygaming" /></div>
		<div className="flex gap-4">
			<a href="#" className="hover:text-gray-400">Home</a>
			{/* <a href="#" className="hover:text-gray-400">About</a>
			<a href="#" className="hover:text-gray-400">Contact</a> */}
		</div>
		<input
			type="text"
			placeholder="Search..."
			disabled
			className="px-4 py-2 rounded-md border border-gray-700 bg-gray-800 text-gray-300 focus:outline-none focus:ring focus:ring-blue-500"
		/>
		</nav>

      {/* Main Content */}
      <div className="flex px-0 py-4 gap-6">
        {/* Left Column */}
        <RecentRecords />

        {/* Middle Column */}
		<main className="flex-1 px-6">
		<div className="grid grid-cols-2 gap-6 h-100 overflow-hidden">
			<TopPlayers />
			<TopRecordHolders />
			<TopMaps />
			<NewMaps />
		</div>
		</main>


      </div>
    </div>
  );
};

export default App;
